import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
    password_change_title: "Escolha sua senha individual",
    password_change_description: "Seu login foi aceito. Escolha uma senha individual com pelo menos 8 caracteres para todas as suas áreas. Seus acessos serão mantidos.",
    password_change_save: "Salvar senha e continuar",
    password_change_error: "Informe senhas novas iguais, com pelo menos 8 caracteres. Escolha uma senha individual.",
    profile_completion_country: "País",
    profile_completion_company: "Empresa ou instituição",
    profile_completion_job_title: "Cargo",

    profile_completion_title: "Complete seu cadastro",
    profile_completion_description: "Seu acesso está ativo. Preencha apenas as informações que faltam para continuar.",
    profile_completion_save: "Salvar e continuar",
    profile_completion_error: "Não foi possível salvar seus dados. Atualize a página para verificar seu acesso e tente novamente.",

    area_eyebrow: "SUA CONTA MAGVENTURE",
    area_heading: "Onde você quer entrar?",
    area_subtitle: "Escolha uma área para continuar. Seus acessos já estão conectados.",
    area_universe_name: "Universe",
    area_lite_name: "Lite",
    area_accelerator_name: "Accelerator",
    area_universe_description: "Conhecimento e recursos MagVenture.",
    area_lite_description: "Aprendizado essencial para explorar.",
    area_accelerator_description: "Seu programa de capacitação e desenvolvimento.",
    area_enter: "Entrar",
    area_opening: "Abrindo…",
    area_loading: "Verificando seus acessos…",
    area_footer: "Uma conta. Acesso às suas áreas disponíveis.",
    area_sign_out: "Sair da conta",
    area_error: "Não foi possível confirmar seu acesso. Tente novamente.",
    area_retry: "Tentar novamente",
    area_empty: "Sua conta não possui áreas ativas. Entre em contato com o administrador.",
    area_login_error: "Não foi possível entrar. Verifique suas credenciais e tente novamente.",

    sf_partner_contact_account: "Se o Contact escolhido não tiver Account, a aprovação reutilizará uma Account compatível ou preparará uma com o nome da empresa revisado e vinculará esse Contact. Nenhuma outra pessoa será criada. Se houver várias Accounts compatíveis, escolha a correta no card.",
    sf_partner_account_reuse: "Account que será reutilizada ao confirmar",
    sf_partner_account_create: "Account que será criada ao confirmar",
    sf_partner_title: "Preparar empresa e pessoa no Salesforce",
    sf_partner_intro: "Para países sem subsidiária, uma Account existente será reutilizada e a nova pessoa será criada como Contact vinculado. Se a Account não existir, a aprovação criará uma Account com o nome da empresa revisado e um Lead. Contacts e Leads existentes serão reutilizados.",
    sf_partner_link: "No Lead novo, Company recebe o nome da empresa revisado. O vínculo do usuário com a Account fica no Universe; esta configuração do Salesforce não tem um vínculo direto de Lead com Account. Accounts novas recebem o status Qualified Lead.",
    sf_partner_existing_lead: "Este Lead existente será reutilizado. A aprovação não cria outra pessoa nem converte o Lead automaticamente.",
    sf_partner_account_choice: "Mais de uma Account corresponde a esta empresa. Escolha a Account correta no card antes de aprovar; nenhuma Account duplicada será criada.",
    sf_review_none_match: "Nenhuma destas pessoas corresponde ao cadastro. Criar um novo Contact.",
    sf_review_reason: "Explique sua decisão sobre a identidade (obrigatório)",
    sf_review_evidence: "Informações coincidentes",
    sf_review_differences: "Informações diferentes",
    sf_review_reason_contact_creation_required: "Selecione o Account. Um novo Contact será criado nele ao confirmar a aprovação.",
    sf_review_reason_account_selection_required: "Revise o Contact e selecione o Account. A mudança de Account exige sua confirmação.",
    sf_review_reason_salesforce_identity_unconfirmed: "Encontramos possíveis pessoas existentes. Selecione o Contact correto ou confirme que nenhuma corresponde ao cadastro.",
    sf_review_reason_lead_conversion_required: "Um Lead existente corresponde a este e-mail. Converta-o no Salesforce e recarregue os registros.",
    sf_review_reason_salesforce_identity_ambiguous: "Várias pessoas correspondem a este e-mail. Compare os detalhes e selecione o Contact correto.",
    sf_review_reason_salesforce_record_deleted: "Um registro correspondente foi excluído. Resolva no Salesforce e recarregue antes de aprovar.",
    sf_review_reason_partner_creation_ambiguous: "Uma criação anterior teve resultado incerto. A reconciliação deve terminar antes de criar outro registro.",
    sf_review_reason_ready: "O Contact e o Account estão disponíveis. Confirme a associação selecionada.",
    sf_review_field_email: "E-mail",
    sf_review_field_phone: "Telefone",
    sf_review_field_firstName: "Nome",
    sf_review_field_lastName: "Sobrenome",
    sf_review_field_fullName: "Nome completo",
    sf_review_field_emailLocalPart: "Nome do e-mail",
    sf_review_field_emailDomain: "Domínio do e-mail",
    sf_review_field_accountId: "Account",
    sf_review_field_companyName: "Empresa",
    sf_review_field_city: "Cidade",
    sf_review_field_state: "Estado",
    sf_review_field_country: "País",
    sf_review_field_title: "Cargo",
    sf_review_title: "Revisar identidade no Salesforce",
    sf_review_intro: "Compare os registros atuais do Salesforce e escolha o Contact e a Account deste cadastro. Os IDs distinguem registros com o mesmo nome.",
    sf_review_loading: "Consultando registros atuais do Salesforce…",
    sf_review_retry: "Recarregar registros do Salesforce",
    sf_review_contact: "Selecione o Contact do Salesforce",
    sf_review_account: "Selecione a Account do Salesforce",
    sf_review_no_account: "Sem Account vinculada",
    sf_review_current: "Vínculo atual do Universe",
    sf_review_unavailable: "Indisponível para seleção",
    sf_review_company: "Account",
    sf_review_account_change: "Confirmo a alteração exibida da Account deste Contact no Salesforce.",
    sf_review_change: "Alteração de Account ao confirmar",
    sf_review_history: "Registros e atividades históricas serão preservados. As próximas atividades do Universe usarão o Contact escolhido. Nenhum registro será mesclado ou excluído.",
    sf_review_commit: "A confirmação salva a identidade e a organização escolhidas e, em seguida, aprova o acesso.",
    sf_review_leads: "Leads também encontrados no Salesforce",
    sf_review_conversion: "Um Lead precisa ser convertido em Contact no Salesforce antes da seleção aqui. Recarregue após a conversão.",
    sf_review_no_person: "Nenhum Contact existente foi encontrado. A empresa confirmada abaixo será usada para criar o Contact antes da aprovação.",
    sf_review_created: "Criado em",
    sf_review_stale: "A tentativa anterior usou uma revisão antiga do perfil. Sua confirmação revisará os dados atuais antes de retomar.",

    identity_management_title: 'Gerenciamento de acessos',
    identity_management_search: 'Buscar por nome, e-mail ou empresa',
    identity_management_role: 'Função',
    identity_management_profile: 'Perfil',
    identity_management_invite: 'Conceder acesso por convite',
    identity_management_review: 'Revisar solicitações pendentes',
    identity_management_invite_ready: 'Convite pronto',
    identity_management_invite_bound: 'Somente esta conta existente pode aceitar o convite. Nenhum e-mail foi enviado.',
    identity_management_open_invite: 'Abrir convite',
    identity_management_invite_terms: 'Um uso, exclusivo para esta conta. O acesso Lite dura 30 dias após o aceite; o convite Accelerator vence em 30 dias. Aplicam-se as regras de conteúdo existentes.',
    identity_management_migration: 'Compatibilidade',
    identity_migration_preserve_legacy_credentials: 'Senha existente do portal preservada',
    identity_migration_missing_credentials: 'Configuração de senha necessária',
    identity_migration_duplicate_email: 'E-mail duplicado — revisar identidade',
    identity_migration_access_flag_mismatch: 'Conflito de acesso — revisão necessária',
    identity_migration_linked_email_mismatch: 'Vínculo do perfil requer revisão',
    identity_migration_missing_established_link: 'Vínculo de identidade requer revisão',
    identity_management_suspend: 'Suspender acesso',
    identity_management_restore: 'Restaurar acesso anterior',
    identity_management_revoke: 'Revogar acesso',
    identity_management_confirm: 'A decisão afeta somente a área selecionada. Confirme para continuar.',
    identity_management_saved: 'Acesso atualizado.',
    identity_management_confirm_action: 'Confirmar',
    identity_management_approval_help: 'O acesso Universe é concedido pelo fluxo de aprovação de usuários pendentes.',
    identity_management_invite_help: 'O novo acesso exige um convite para esta área. O usuário aceita com sua conta existente.',
    identity_access_title: 'Meus acessos',
    identity_access_subtitle: 'Suas áreas MagVenture e solicitações de acesso.',
    identity_access_area: 'Área',
    identity_access_enter: 'Abrir',
    identity_access_unavailable: 'Acesso indisponível',
    identity_request_universe: 'Solicitar acesso ao Universe',
    identity_request_explanation: 'Seu acesso atual continua enquanto a solicitação para o Universe é analisada.',
    identity_request_submit: 'Enviar solicitação',
    identity_request_sent: 'Sua solicitação foi enviada para análise.',
    identity_status_active: 'Ativo',
    identity_status_pending: 'Aguardando análise',
    identity_status_suspended: 'Suspenso',
    identity_status_revoked: 'Revogado',
    identity_status_rejected: 'Não aprovado',
    identity_status_none: 'Não solicitado',
    identity_status_legacy: 'Acesso existente',
    lite_invite_group_unavailable: 'Sem conteúdo disponível',
    lite_invite_access_time: 'Tempo de acesso',
    lite_invite_days: 'dias',
    lite_invite_advanced: 'Opções avançadas',
    lite_invite_default_content_help: 'Todo o conteúdo configurado para o Lite fica liberado por padrão. Use as opções avançadas para personalizar o acesso.',
    lite_invite_description: 'Crie um convite reutilizável para o Universe Lite.',
    lite_invite_duration_help: 'Cada pessoa recebe este período ao concluir o cadastro. Alterações valem apenas para novos cadastros.',
    lite_invite_legacy: 'Este convite mantém as regras originais de data fixa. O prazo continua disponível nas opções avançadas.',

    ...analyticsTranslations.Portuguese,
    "upload_success": "Upload enviado com sucesso. Aguardando aprovação.",
    "upload_title": "Formulário de solicitação de upload de conteúdo",
    "Context": 'Contexto',
    "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
    "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
    "portal_registration_participant_limit_reached": "O cadastro não está disponível porque o número máximo de participantes para este acesso foi atingido. Entre em contato com a pessoa responsável pelo seu acesso MagVenture para obter ajuda.",
    "portal_registration_invite_invalid": "Este link de convite é inválido ou expirou.",
    "lite_registration_success_title": "Cadastro concluído",
    "lite_registration_success_email_text": "Seu acesso ao MagVenture Universe Lite está pronto. Enviamos um e-mail de boas-vindas com o link de acesso. Entre com o e-mail e a senha que você acabou de cadastrar.",
    "lite_registration_success_text": "Seu acesso ao MagVenture Universe Lite está pronto. Entre com o e-mail e a senha que você acabou de cadastrar.",
    "lite_registration_success_action": "Ir para o login do Lite",
    "accelerator_registration_success_title": "Cadastro concluído",
    "accelerator_registration_success_email_text": "Seu acesso ao MagVenture Accelerator Program está pronto. Enviamos um e-mail de boas-vindas com o link de acesso. Entre com o e-mail e a senha que você acabou de cadastrar.",
    "accelerator_registration_success_text": "Seu acesso ao MagVenture Accelerator Program está pronto. Entre com o e-mail e a senha que você acabou de cadastrar.",
    "accelerator_registration_success_action": "Ir para o login do Accelerator",
    "describe_as_upload": "Preencha as informações abaixo e faça o upload dos arquivos que você gostaria de propor como novo conteúdo para o MagVenture Universe. Em alguns dias, nossa equipe de suporte entrará em contato com você para fornecer mais informações sobre sua solicitação.",
    "title": "Título",
    "table": "Tipo de conteúdo",
    "tags": "Tags",
    "tag-types": "Tipos de tag",
    "categories": "Categorias",
    "sub-categories": "Subcategorias",
    "document": "Documento",
    "image": "Imagem",
    "audience_access_available_audiences": "Públicos com acesso",
    "audience_access_hcp": "Disponível para profissionais de saúde",
    "audience_access_partner": "Disponível para Partners",
    "audience_access_staff_us": "Disponível para a equipe dos EUA",
    "audience_access_staff_global": "Disponível para a equipe global",

    "cancel": "Cancelar",
    "send": "Enviar",
    'share_link': 'Compartilhar link',
    'share_link_description': 'Qualquer pessoa com este link pode acessar este conteúdo por {days} dias. Copie e compartilhe com segurança.',
    'share_link_label': 'Compartilhe este link:',
    'copy_link': 'Copiar link',
    'copied': 'Copiado!',
    'share_link_warning': 'Este link expirará em {days} dias.',
    'share_link_duration': 'Validade (dias)',
    'copy': 'Copiar',
    "login_title": "Por favor, faça login",
    "login_title_essentials": "Bem-vindo ao MagVenture Universe Lite",
    "accelerator_brand_name": "MagVenture",
    "accelerator_brand_program": "Accelerator Program",
    "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
    "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
    "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
    "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
    "register": "Registrar",
    "login": "Entrar",
    "email": "E-mail",
    "registration_professional_email_hint": "Use seu e-mail profissional, por exemplo, nome@suaempresa.com.",
    "password": "Senha",
    "signin": "Entrar",
    "session_expired_sign_in_again": "Sua sessão expirou. Entre novamente para continuar.",
    "reset_password": "Redefinir senha",
    "fill_the_field": "Preencha o campo",
    "success": "Obrigado!",
    "account_successfully_created": "Nossa equipe analisará sua solicitação e entrará em contato caso precise de mais informações. Você receberá um e-mail assim que sua conta for aprovada e estiver pronta para uso.",
    "close": "Fechar",
    "salutation": "Saudação",
    "first_name": "Nome",
    "last_name": "Sobrenome",
    "company_name": "Nome da empresa",
    "job_title": "Cargo/Cargo",
    "industry": "Setor",
    "state": "Estado/Província",
    "zipcode": "CEP",
    "phone_number": "Número de telefone",
    "password_confirmation": "Confirmação de senha",
    "mr": "Sr",
    "mrs": "Sra",
    "ms": "Srta",
    "signup": "Cadastre-se",
    "are_you_a_patient_or_a_therapist": "Você é um paciente ou um terapeuta?",
    "create_your_password": "Crie sua senha",
    "finish": "Concluir",
    "create_your_account": "Crie sua conta",
    "back": "Voltar",
    "next": "Próximo",
    "create_a_password": "Crie uma senha",
    "enter_a_password_for_your_account": "Digite uma senha para sua conta",
    "subscribe_to_newsletter": "Sim, gostaria de receber atualizações educacionais, recursos de TMS e informações sobre eventos da MagVenture.",
    "subscribe_to_newsletter_information": "Você pode cancelar a assinatura a qualquer momento. Respeitamos sua caixa de entrada profissional e compartilhamos apenas conteúdo relevante.",
    "i_accept_the": "Aceito a",
    "privacy_policy": "Política de Privacidade",
    "send": "Enviar",
    "back_to_login": "Voltar ao login",
    "enter_your_email_to_recover_your_password": "Digite seu e-mail para recuperar sua senha",
    "access_the_recovery_link_that_was_sent_to_your_email": "Acesse o link de recuperação que foi enviado para seu e-mail",
    "check_your_email": "Verifique seu e-mail",
    "new_password": "Nova senha",
    "confirm_new_password": "Confirmar nova senha",
    "new_password_and_new_password_confirmation_are_not_the_same": "Nova senha e nova confirmação de senha não são a mesma coisa",
    "password_changed_successfully": "Senha alterada com sucesso!",
    "create_a_new_password": "Criar uma nova senha",
    "enter_a_new_password_for_your_account": "Digite uma nova senha para sua conta",
    "save": "Salvar",
    "one_uppercase_letter": "Uma letra maiúscula",
    "one_number": "Um número",
    "at_least_6_characters": "Pelo menos 6 caracteres",
    "at_least_1_special_character": "Pelo menos 1 caractere especial",
    "accept_terms": "Aceitar os termos",
    "password_and_password_confirmation_must_match": "A senha e a confirmação da senha devem ser iguais",
    "see_all": "Ver tudo",
    "watch_live_now": "Assista ao vivo agora",
    "courses_available_for_you": "Cursos disponíveis para você",
    "partners-and-staffs_available_for_you": "Partners and Staff disponíveis para você",
    "articles_available_for_you": "Artigos disponíveis para você",
    "podcasts_available_for_you": "Podcasts disponíveis para você",

    "support-materials_available_for_you": "Materiais de apoio à prática disponíveis para você",
    "marketing-materials_available_for_you": "Materiais de marketing prático disponíveis para você",
    "service-supports_available_for_you": "Service & Support disponível para você",
    "media-templates_available_for_you": "Modelos de mídia social disponíveis para você",
    "videos_available_for_you": "Vídeos disponíveis para você",
    "photos_available_for_you": "Fotos disponíveis para você",

    "documents_available_for_you": "Documentos disponíveis para você",

    "courses": "Cursos",
    "knowledge-trails": "Learning Paths",
    "partners-and-staffs": "Partners and Staff",
    "articles": "Artigos",
    "podcasts": "Podcasts",
    "documents": "Documentos",
    "home": "Página inicial",
    "favorites": "Favoritos",
    "no_favorites_message": "Você ainda não adicionou nenhum favorito.",
    "favorites_workspace_title": "Organize seus salvos",
    "favorites_workspace_description": "Crie folders, arraste itens entre eles e deixe seus materiais salvos mais fáceis de encontrar.",
    "favorites_unfiled": "Sem folder",
    "favorites_unfiled_caption": "Novos favoritos entram aqui primeiro",
    "favorites_unfiled_description": "Tudo o que você salvou e ainda não organizou em um folder.",
    "favorites_folder_description": "Arraste itens para cá, reordene ou mova vários de uma vez.",
    "favorites_new_folder": "Novo folder",
    "favorites_create_folder": "Criar folder",
    "favorites_folder_name_placeholder": "Nome do folder",
    "favorites_delete_folder_confirm": "Excluir este folder e mover os itens de volta para Sem folder?",
    "favorites_current_view": "Visualização atual",
    "favorites_grid": "Grade",
    "favorites_list": "Lista",
    "favorites_drag_hint": "Arraste para reordenar ou mover",
    "favorites_selected": "selecionados",
    "favorites_move_to": "Mover para",
    "favorites_move_selected": "Mover selecionados",
    "favorites_empty_unfiled": "Salve cursos ou arquivos e eles aparecerão aqui antes de serem movidos para um folder.",
    "favorites_empty_folder": "Este folder está vazio. Arraste itens para cá ou use a movimentação em lote.",
    "faq": "Perguntas frequentes",
    "no_faqs_available": "Nenhuma pergunta frequente disponível.",
    "support": "Suporte",
    "contact_us": "Fale conosco",
    "my_account": "Minha Conta",
    "my_certificates": "Meus Certificados",
    "logout": "Sair",
    "search": "Pesquisar",
    "frequently_asked_questions": "Perguntas frequentes",
    "how_can_we_help_you": "Como podemos ajudar você?",
    "add_new_ticket": "Adicionar novo ingresso",
    "all_tickets": "Todos os ingressos",
    "pending": "Pendente",
    "closed_tickets": "Ingressos fechados",
    "videos_and_contents": "Vídeos e conteúdos",
    "ticket_information": "Informações do ticket",
    "add_reply": "Adicionar resposta",
    "close_ticket": "Fechar ticket",
    "status": "Status",
    "ticket_id": "ID do ticket",
    "created_date": "Data de criação",
    "category_department": "Categoria/Departamento",
    "give_feedback": "Dê seu feedback",
    "how_would_you_rate_the_way_this_request_was_handled": "Como você avaliaria a forma como esta solicitação foi tratada",
    "subject": "Assunto",
    "area_departament": "Área / departamento",
    "message": "Mensagem",
    "create_a_new_ticket": "Criar um novo ticket",
    "describe_as_soon_as_possible": "Descreva seu problema e selecione o departamento apropriado para que nossa equipe possa ajudá-lo o mais rápido possível",
    "no_records_found": "Nenhum registro encontrado",
    "showing": "Exibindo",
    "of": "de",
    "results": "resultados",
    "subject_title": "Assunto/Título",
    "last_updated": "Última atualização",
    "cancel": "Cancelar",
    "registration_data": "Dados de registro",
    "updated_successfully": "Atualizado com sucesso",
    "created_successfully": "Criado com sucesso",
    "edit": "Editar",
    "done": "Feito",
    "filters": "Filtros",
    "search.shareResources": "Compartilhar recursos",
    "search.backToResults": "Voltar aos resultados",
    "search.download": "Baixar",
    "search.filters": "Tipos de conteúdo",
    "search.loading": "Pesquisando",
    "search.error": "A busca está indisponível",
    "search.errorHelp": "Tente pesquisar novamente.",
    "search.start": "Digite pelo menos dois caracteres para pesquisar.",
    "search.degraded": "A busca relacionada está temporariamente indisponível. Exibindo correspondências do catálogo.",
    "search.refine": "Exibindo um conjunto limitado. Refine a busca para encontrar resultados mais específicos.",
    "search.result": "resultado",
    "search.results": "resultados",
    "search.noResults": "Nenhum resultado para",
    "search.emptyHelp": "Confira o código do produto ou tente menos palavras. Selecione Todos para buscar em todos os tipos.",
    "search.noDirect": "Nenhuma correspondência direta. Estes recursos podem estar relacionados à sua busca.",
    "search.related": "Resultados relacionados",
    "search.showRelated": "Mostrar resultados relacionados",
    "search.types.all": "Todos",
    "search.types.videos": "Vídeos",
    "search.types.images": "Imagens",
    "search.types.documents": "Documentos e materiais",
    "search.types.learning": "Treinamento e aprendizagem",
    "search.types.articles": "Artigos",
    "search.sections.trainingLearning": "Treinamento e Aprendizagem",
    "search.sections.documents": "Documentos",
    "search.sections.images": "Imagens",
    "category": "Categoria",
    "filter": "Filtrar",
    "clear": "Limpar",
    "support_materials": "Material de Suporte",
    "marketing_materials": "Material de Marketing",
    "media_templates": "Modelo de Mídia",
    "videos": "Vídeos",
    "photos": "Fotos",
    "support-materials": "Materiais de Apoio à Prática",
    "marketing-materials": "Materiais de Marketing",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Materiais de apoio a vendas disponíveis para você",
    "sales_support_materials_empty": "Nenhum material de apoio a vendas disponível no momento.",
    "sales_support_materials_error": "Não foi possível carregar os materiais de apoio a vendas. Tente novamente.",
    "sales_support_materials_unavailable": "Materiais de apoio a vendas temporariamente indisponíveis",
    "service-supports": "Service & Support",
    "service_support": "Service & Support",
    "support_videos": "Support Videos",
    "support_videos_empty": "Ainda não há vídeos de suporte disponíveis.",
    "support_videos_unavailable": "Vídeos de suporte indisponíveis",
    "support_videos_error": "Não foi possível carregar os vídeos de suporte. Tente novamente.",
    "support_video_unavailable": "Vídeo de suporte indisponível",
    "support_video_media_missing": "Vídeo não disponível",
    "support_video_media_missing_description": "Este vídeo de suporte ainda não possui uma mídia reproduzível.",
    "support_video_about": "Sobre este vídeo",
    "media-templates": "Modelos para Mídias Sociais",
    "existing_users": "Usuários existentes",
    "enter_credentials_to_continue": "Digite suas credenciais de login para continuar de onde parou.",
    "new_users": "Novos usuários",
    "register_link_text": "Registrar",
    "register_and_gain_access_part1": "Precisa de uma conta? Vá para ",
    "register_and_gain_access_part2": " e obtenha acesso completo à nossa plataforma exclusiva de aprendizado e recursos.",

    "contact.topicCategory": "Selecione a categoria do tópico",
    "contact.topicCategory.label": "Categoria do Tópico",
    "contact.chooseSubject": "Escolha o assunto que melhor se encaixa no seu pedido.",
    "contact.message": "Mensagem",
    "contact.message.label": "Mensagem",
    "contact.describeIssue": "Descreva seu problema em detalhes. Nossa equipe responderá o mais rápido possível.",
    "contact.fileAttachment": "Anexar um arquivo",
    "contact.fileAttachment.label": "Anexo de Arquivo",
    "contact.attachmentHelp": "Opcionalmente, você pode anexar uma captura de tela ou arquivo relacionado ao seu pedido. (e.g. JPG, PNG, PDF, DOC)",
    "contact.preferredContact": "Forma de contato preferencial",
    "contact.preferredContact.label": "Forma de Contato Preferencial",
    "contact.contactPreference": "Como você prefere ser contatado em relação a este problema?",
    "contact.maximum_characters": "Máximo: 1000 caracteres",
    "contact.email.label": "E-mail",
    "contact.phone.label": "Telefone",
    "contact.technical_support": "Suporte Técnico",
    "contact.questions_about_products": "Dúvidas sobre Produtos/Serviços",
    "contact.access_issues": "Problemas de Acesso",
    "contact.suggestion": "Sugestão",
    "contact.other": "Outro",
    "contact.file": "Escolha os arquivos",
    "contact.submit": "Enviar",
    "contact.is_required": "é obrigatório",
    "contact.success": "Contato enviado com sucesso",
    "register.undertems": "O acesso ao MagVenture Universe está sujeito a análise e aprovação. As solicitações de registro podem levar até 2 dias úteis para serem aprovadas.",
    "courses-webinars-training": "Cursos, Webinars e Treinamentos",
    "usshop": "Loja dos EUA",
    "web_notifications_title": "Ative as notificações",
    "web_notifications_description": "Receba novidades de cursos, respostas do suporte e atividades importantes direto no navegador.",
    "web_notifications_body": "Fique por dentro sem precisar manter a plataforma aberta. Você pode mudar isso depois nas configurações do navegador.",
    "web_notifications_bullet_updates": "Novos conteúdos, lançamentos e atualizações da plataforma",
    "web_notifications_bullet_support": "Respostas do suporte e andamento dos tickets",
    "web_notifications_bullet_reminders": "Lembretes importantes quando você estiver fora da aba",
    "web_notifications_enable": "Ativar notificações",
    "web_notifications_later": "Agora não",
    "web_notifications_enabled": "Notificações ativadas com sucesso.",
    "web_notifications_not_supported": "Este navegador não oferece suporte a notificações web.",
    "web_notifications_denied": "As notificações estão bloqueadas nas configurações do navegador.",
    "notifications": "Notificações",
    "unread_notifications": "notificações não lidas",
    "unread_notification": "notificação não lida",
    "unread": "Não lida",
    "mark_all_notifications_read": "Marcar todas como lidas",
    "notifications_update_error": "Não foi possível atualizar as notificações.",
    "try_again": "Tentar novamente",
    "notifications_load_error": "Não foi possível carregar as notificações",
    "notifications_load_error_description": "Verifique sua conexão e tente novamente.",
    "notifications_empty": "Nenhuma notificação por enquanto",
    "notifications_empty_description": "Atualizações e atividades importantes aparecerão aqui.",
    "notification_not_found": "Notificação não encontrada",
    "notification_not_found_description": "Esta notificação não está mais disponível ou você não tem acesso a ela.",
    "back_to_notifications": "Voltar às notificações",
    "open_notification": "Abrir",
    "loading_notifications": "Carregando notificações",
    "loading_notification": "Carregando notificação",
    "notifications_subtitle": "Acompanhe atualizações, novos cursos e atividades importantes em um só lugar.",
    "recent_activity": "Atividade recente",
    "notifications_all_read": "Tudo em dia por aqui",
    "staff_essentials_invites_title_required": "O título é obrigatório.",
    "staff_essentials_invites_updated": "Convite atualizado.",
    "staff_essentials_invites_created": "Convite criado.",
    "staff_essentials_invites_link_unavailable": "O link do convite não está disponível.",
    "staff_essentials_invites_link_copied": "Link do convite copiado.",
    "staff_essentials_invites_copy_prompt": "Copie este link de convite:",
    "staff_essentials_invites_eyebrow": "MagVenture Universe",
    "staff_essentials_invites_menu_title": "MVU Lite Invitations",
    "staff_essentials_invites_title": "MVU Lite Invitations",
    "staff_essentials_invites_subtitle": "Crie links de convite para o MagVenture Universe Lite e acompanhe quantos cadastros cada link consumiu.",
    "staff_essentials_invites_refresh": "Atualizar",
    "staff_essentials_invites_create": "Criar convite",
    "staff_essentials_invites_total": "Total de convites",
    "staff_essentials_invites_active": "Ativos",
    "staff_essentials_invites_registrations": "Cadastros",
    "staff_essentials_invites_remaining": "Restantes",
    "staff_essentials_invites_links": "Links de convite",
    "staff_essentials_invites_found_singular": "convite encontrado",
    "staff_essentials_invites_found_plural": "convites encontrados",
    "staff_essentials_invites_none_created": "Nenhum link de convite criado ainda",
    "staff_essentials_invites_syncing": "Sincronizando",
    "staff_essentials_invites_live_data": "Dados ao vivo",
    "staff_essentials_invites_loading_links": "Carregando links de convite...",
    "staff_essentials_invites_column_title": "Título",
    "staff_essentials_invites_column_link": "Link",
    "staff_essentials_invites_column_status": "Status",
    "staff_essentials_invites_column_used": "Usado",
    "staff_essentials_invites_column_remaining": "Restante",
    "staff_essentials_invites_column_expires": "Expira",
    "staff_essentials_invites_column_created": "Criado",
    "staff_essentials_invites_column_actions": "Ações",
    "staff_essentials_invites_active_status": "Ativo",
    "staff_essentials_invites_inactive_status": "Inativo",
    "staff_essentials_invites_unlimited": "Ilimitado",
    "staff_essentials_invites_copy_link": "Copiar link",
    "staff_essentials_invites_history": "Histórico",
    "staff_essentials_invites_edit": "Editar",
    "staff_essentials_invites_empty_title": "Nenhum convite Lite ainda",
    "staff_essentials_invites_empty_description": "Crie o primeiro link de convite para começar a acompanhar cadastros.",
    "staff_essentials_invites_edit_modal": "Editar convite",
    "staff_essentials_invites_create_modal": "Criar convite",
    "staff_essentials_invites_generated_by_strapi": "Escolha um código único e vincule o convite a uma Account do Salesforce.",
    "staff_essentials_invites_field_title": "Título",
    "staff_essentials_invites_field_code": "Código do convite",
    "staff_essentials_invites_field_company": "Company Name",
    "staff_essentials_invites_code_required": "O código do convite é obrigatório.",
    "staff_essentials_invites_company_required": "Company Name é obrigatório.",
    "staff_essentials_invites_column_company": "Empresa",
    "staff_essentials_invites_loading_companies": "Carregando empresas...",
    "staff_essentials_invites_search_companies": "Digite para pesquisar empresas.",
    "staff_essentials_invites_no_companies": "Nenhuma empresa encontrada.",
    "staff_essentials_invites_company_select_required": "Selecione uma Company da lista.",
    "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
    "staff_essentials_invites_field_expires_at": "Expira em",
    "staff_essentials_invites_history_modal": "Histórico do convite",
    "staff_essentials_invites_loading_history": "Carregando histórico...",
    "staff_essentials_invites_no_institution": "Sem instituição",
    "staff_essentials_invites_no_registrations": "Nenhum cadastro para este convite ainda.",
    "staff_essentials_invites_locked_content_title": "Acesso ao conteúdo",
    "staff_essentials_invites_locked_content_description": "Os conteúdos marcados ficam liberados para os usuários cadastrados com este convite. Desmarque um item para bloquear o acesso.",
    "staff_essentials_invites_locked_content_selected": "com acesso",
    "staff_essentials_invites_locked_content_select_visible": "Liberar resultados visíveis",
    "staff_essentials_invites_locked_content_clear": "Bloquear todo o conteúdo",
    "staff_essentials_invites_locked_content_search": "Buscar conteúdo Lite",
    "staff_essentials_invites_locked_content_filter": "Tipo de conteúdo",
    "staff_essentials_invites_locked_content_all_types": "Todos os tipos",
    "staff_essentials_invites_locked_content_loading": "Carregando catálogo...",
    "staff_essentials_invites_locked_content_empty": "Nenhum conteúdo encontrado.",
    "staff_essentials_invites_locked_content_error": "Não foi possível carregar o catálogo Lite.",
    "staff_essentials_invites_content_preset_title": "Predefinição de conteúdo",
    "staff_essentials_invites_content_preset_description": "Selecione um ou mais grupos para substituir a seleção atual pelos conteúdos combinados desses grupos. Personalize itens individuais nas Opções avançadas.",
    "staff_essentials_invites_content_preset_placeholder": "Grupo de conteúdo predefinido",
    "staff_essentials_invites_content_preset_custom": "Seleção personalizada (sem predefinição)",
    "staff_essentials_invites_content_preset_loading": "Carregando predefinições de conteúdo...",
    "staff_essentials_invites_content_preset_error": "Não foi possível carregar as predefinições de conteúdo.",
    "staff_essentials_invites_content_preset_empty": "Nenhuma predefinição ativa está disponível. Você ainda pode selecionar conteúdos manualmente.",
    "staff_essentials_invites_content_preset_applied": "Predefinição aplicada",
    "staff_essentials_invites_content_preset_applied_description": "Estes conteúdos foram copiados para o convite. Você pode personalizá-los abaixo sem alterar o grupo no Strapi.",
    "exclusive_content_title": "Conteúdo exclusivo",
    "exclusive_content_message": "Este recurso não está incluído no seu acesso atual. Fale com a pessoa que enviou seu convite ou com seu representante MagVenture para consultar as opções de acesso. Você pode continuar explorando os recursos disponíveis no seu portal.",
    "continue_browsing": "Continuar navegando",
    "survey_load_error": "Não foi possível carregar esta enquete.",
    "survey_unavailable": "Enquete indisponível",
    "survey_back_to_course": "Voltar ao curso",
    "survey_thank_you": "Obrigado pelo seu feedback",
    "survey_completed_description": "Suas respostas foram salvas. Você pode continuar o curso.",
    "survey_submitted": "Enviada",
    "survey_continue_course": "Continuar curso",
    "survey_course_feedback": "Feedback do curso",
    "survey_intro_description": "Responda às perguntas a seguir sobre sua experiência com o treinamento.",
    "survey_questions": "perguntas",
    "survey_minutes": "minutos",
    "survey_account_linked": "Salva na sua conta",
    "survey_start": "Iniciar enquete",
    "survey_progress": "Progresso da enquete",
    "survey_optional": "Opcional",
    "survey_required": "Obrigatória",
    "survey_text_placeholder": "Digite sua resposta aqui...",
    "survey_back": "Voltar",
    "survey_submit": "Enviar feedback",
    "survey_continue": "Continuar",
    "survey_required_answer": "Esta pergunta é obrigatória.",
    "survey_required_before_quiz": "Conclua a enquete obrigatória antes de iniciar este quiz.",
    "survey_required_title": "Enquete obrigatória",
    "survey_open": "Abrir enquete",
    "survey_completed_action": "Enquete concluída",
    "survey_complete_required": "Concluir enquete obrigatória",
    "survey_course_completed": "Curso concluído",
    "survey_next_step": "Próxima etapa",
    "survey_share_experience": "Compartilhe sua experiência",
    "survey_opens_in": "Abrindo a enquete em",
    "survey_seconds": "segundos",
    "survey_answer_now": "Responder enquete",
    "survey_stay_here": "Permanecer aqui",
    "user_approvals_menu_title": "Aprovações de usuários",
    "user_approvals_eyebrow": "Gestão de acesso",
    "user_approvals_title": "Aprovações de usuários",
    "user_approvals_subtitle": "Analise as solicitações de acesso pendentes atribuídas ao seu escopo de aprovação.",
    "user_approvals_pending_count": "pendentes",
    "user_approvals_refresh": "Atualizar",
    "user_approvals_pending_requests": "Solicitações pendentes",
    "user_approvals_search_placeholder": "Buscar por nome, e-mail ou empresa",
    "user_approvals_unavailable": "Aprovações indisponíveis",
    "user_approvals_auth_required": "Entre na sua conta para acessar as solicitações.",
    "user_approvals_not_authorized": "Nenhum responsável de aprovação ativo está vinculado a esta conta.",
    "user_approvals_network_error": "Erro de conexão. Tente novamente.",
    "user_approvals_load_error": "Não foi possível carregar as solicitações de aprovação.",
    "user_approvals_empty": "Não há aprovações pendentes.",
    "user_approvals_empty_description": "Novas solicitações atribuídas ao seu escopo aparecerão aqui.",
    "user_approvals_no_search_results": "Nenhuma aprovação encontrada",
    "user_approvals_no_search_results_description": "Tente outro nome, e-mail ou empresa.",
    "user_approvals_created_at": "Solicitada em",
    "user_approvals_name": "Nome",
    "user_approvals_email": "E-mail",
    "user_approvals_edit_company_name": "Editar nome da empresa (opcional)",
    "user_approvals_partner_description": "Revise o cadastro e aprove ou rejeite o acesso. A correção do nome da empresa é opcional.",
    "user_approvals_company": "Nome da empresa",
    "user_approvals_country": "País",
    "user_approvals_region": "Região",
    "user_approvals_location": "Localização",
    "user_approvals_status": "Status",
    "user_approvals_actions": "Ações",
    "user_approvals_approved": "Aprovado",
    "user_approvals_rejected": "Rejeitado",
    "user_approvals_approve": "Aprovar",
    "user_approvals_reject": "Rejeitar",
    "user_approvals_already_processed": "Esta solicitação de aprovação já foi processada.",
    "user_approvals_process_error": "Não foi possível processar esta solicitação.",
    "user_approvals_approve_success": "Usuário aprovado com sucesso.",
    "user_approvals_reject_success": "Usuário rejeitado com sucesso.",
    "user_approvals_manual_review_required": "Revisão manual necessária",
    "user_approvals_company_informed": "Empresa informada no cadastro",
    "user_approvals_phone": "Telefone",
    "user_approvals_customer_select": "Nome da empresa (Account no Salesforce)",
    "user_approvals_search_companies": "Buscar cliente ou clínica",
    "user_approvals_no_companies": "Nenhum cliente ou clínica correspondente",
    "user_approvals_company_load_error": "Não foi possível carregar os clientes ou clínicas.",
    "user_approvals_confirm_title": "Aprovar usuário",
    "user_approvals_confirm_description": "Revise o cadastro e confirme o cliente antes de aprovar o acesso.",
    "user_approvals_association_confirmation": "Este usuário será associado a:",
    "user_approvals_use_registered_company": "Aprovar com a clínica informada no cadastro",
    "user_approvals_registered_company_confirmation": "Será criado um Contact no Salesforce com os dados do cadastro. Clínica informada:",
    "user_approvals_confirm_approval": "Confirmar aprovação",
    "analytics_hub_traffic": "Tráfego do Competitive Hub",
    "analytics_hub_page": "Página",
    "mag.title": "Maggie",
    "mag.subtitle": "Seu companheiro de aprendizagem",
    "mag.preview_badge": "Piloto",
    "mag.open_aria": "Abrir assistente Maggie",
    "mag.close_aria": "Fechar assistente Maggie",
    "mag.launcher_tooltip": "Conversar com a Maggie",
    "mag.intro_title": "Olá! Eu sou a Maggie.",
    "mag.intro_body": "Como posso ajudar?",
    "mag.dismiss_intro_aria": "Dispensar apresentação da Maggie",
    "mag.welcome": "Olá! Eu sou a Maggie. O que você gostaria de explorar hoje?",
    "mag.welcome_named": "Olá, {name}! Eu sou a Maggie. O que você gostaria de explorar hoje?",
    "mag.quick.hub_news": "Últimas notícias do Competitive Hub",
    "mag.quick.hub_research": "Pesquisas recentes do Competitive Hub",
    "mag.quick.hub_events": "Próximos eventos do Competitive Hub",
    "mag.quick_actions_label": "Experimente perguntar",
    "mag.quick.find_course": "Encontrar um curso",
    "mag.quick.explore_trails": "Explorar Learning Paths",
    "mag.quick.continue_learning": "Continuar aprendendo",
    "mag.quick.product_tutorials": "Encontrar tutoriais de produtos",
    "mag.quick.about_magventure": "Entender como o MagVenture funciona",
    "mag.placeholder": "Faça uma pergunta à Maggie...",
    "mag.composer_label": "Mensagem para a Maggie",
    "mag.send_aria": "Enviar mensagem para a Maggie",
    "mag.preview_response": "Posso responder usando o acervo de aprendizagem da MagVenture.",
    "mag.local_error": "A Maggie não conseguiu preparar a resposta. Tente novamente.",
    "mag.typing": "A Maggie está preparando uma resposta",
    "mag.you_label": "Sua mensagem",
    "mag.mag_label": "Mensagem da Maggie",
    "mag.avatar_fallback": "Avatar alternativo da Maggie",
    "mag.loading": "Abrindo a Maggie...",
    "mag.sources": "Fontes",
    "mag.page": "Página",
    "mag.feedback_question": "Esta resposta ajudou?",
    "mag.feedback_up": "Resposta útil",
    "mag.feedback_down": "Resposta não foi útil",
    "mag.feedback_thanks": "Obrigado pelo feedback.",
    "mag.feedback_error": "Não foi possível enviar o feedback. Tente novamente.",
    "mag.feedback_form.title": "Enviar feedback",
    "mag.feedback_form.open": "Clique aqui para enviar feedback",
    "staff_essentials_invites_content_locked": "Bloqueado",
    "staff_essentials_invites_content_available": "Acesso liberado",
    "mag.feedback_form.description": "Seu feedback será salvo na nossa caixa interna para a equipe MagVenture revisar. Até 4.000 caracteres.",
    "mag.feedback_form.placeholder": "Seu feedback",
    "mag.feedback_form.submit": "Enviar feedback",
    "mag.feedback_form.cancel": "Voltar ao chat",
    "mag.competitor_feedback.prompt": "Olá! Posso ajudar você a explorar o Competitive Hub. O que gostaria de saber? Você também pode usar o botão de feedback abaixo para enviar uma sugestão.",
    "mag.competitor_feedback.prompt_named": "Olá, {name}! Posso ajudar você a explorar o Competitive Hub. O que gostaria de saber? Você também pode usar o botão de feedback abaixo para enviar uma sugestão.",
    "mag.competitor_feedback.placeholder": "Compartilhe seu feedback sobre o Competitor Hub...",
    "mag.competitor_feedback.success": "Obrigado! Seu feedback foi salvo para nossa equipe revisar.",
    "mag.competitor_feedback.error": "Não foi possível salvar seu feedback. Sua mensagem continua no formulário; tente novamente.",
    "mag.feedback_reason.not_helpful": "Não ajudou",
    "mag.feedback_reason.wrong_source": "Fonte incorreta",
    "mag.feedback_reason.unclear": "Pouco clara",
    "mag.feedback_reason.too_general": "Muito geral",
    "mag.feedback_reason.unsafe": "Insegura",
    "competitive_intelligence_menu_title": "Inteligência Competitiva",
    "competitive_intelligence_eyebrow": "Inteligência de mercado",
    "competitive_intelligence_title": "Inteligência Competitiva",
    "competitive_intelligence_description": "Uma visão atual das pesquisas competitivas, sinais de mercado e fontes sociais acompanhadas pela MagVenture.",
    "competitive_intelligence_freshness_unknown": "Horário de atualização indisponível",
    "competitive_intelligence_overview_heading": "Visão geral de inteligência",
    "competitive_intelligence_metric_competitors": "Concorrentes monitorados",
    "competitive_intelligence_metric_research": "Registros de pesquisa",
    "competitive_intelligence_metric_market": "Sinais de mercado",
    "competitive_intelligence_metric_social": "Publicações sociais",
    "competitive_intelligence_sources_title": "Fontes de pesquisa",
    "competitive_intelligence_sources_description": "Cobertura e atualização do banco atual de Inteligência Competitiva.",
    "competitive_intelligence_records": "registros",
    "competitive_intelligence_sources_empty": "Ainda não há detalhes por fonte.",
    "competitive_intelligence_loading": "Carregando a visão geral de Inteligência Competitiva",
    "competitive_intelligence_empty_title": "Ainda não há dados de inteligência",
    "competitive_intelligence_empty_description": "O pipeline ainda não publicou registros para esta visão geral.",
    "competitive_intelligence_denied_title": "Acesso não disponível",
    "competitive_intelligence_denied_description": "Sua conta não tem acesso à Inteligência Competitiva.",
    "competitive_intelligence_unavailable_title": "Inteligência Competitiva indisponível",
    "competitive_intelligence_unavailable_description": "O serviço não pode ser acessado agora. Tente novamente em instantes.",
    "competitive_intelligence_error_title": "Não foi possível carregar a visão geral",
    "competitive_intelligence_error_description": "Uma resposta inesperada impediu o carregamento desta visão geral.",
    ...competitiveIntelligenceResearchTranslations.Portuguese
}
